import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from '@template/App';
import store from '@utils/redux/store';
import { firebaseInit } from '@utils/firebase';
import { systemInit } from '@utils/system';

import '@assets/css/fonts.scss';
import '@assets/css/globalStyle.scss';

firebaseInit();

systemInit();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app-root')
);
